<script>
    import {onMount} from 'svelte';
    // Lisätään ajankohtaista-kirjoitukset tähän. Päivämäärä nimessä auttaa järjestämisessä. Nimen voi keksiä ja url tulee sivun tiedostosta.
    // Tässä oikea .svelte -sivu ladataan sivun käyttöön
    import Ajankohtaista_2025_06_20 from "../ajankohtaista/2025-06-20_juhannus.svelte";
    import Ajankohtaista_2025_05_01 from "../ajankohtaista/2025-05-01_kesa_aikataulut.svelte";
    import Ajankohtaista_2025_04_12 from "../ajankohtaista/2025-04-12_paasiainen.svelte";
    import Ajankohtaista_2025_01_19 from "../ajankohtaista/2025-01-19-helmikuun-leirit.svelte";
    import Ajankohtaista_2024_12_31 from "../ajankohtaista/2024-12-31_uusivuosi.svelte";
    import Ajankohtaista_2024_12_21 from "../ajankohtaista/2024-12-21_jouluinfo.svelte";
    import Ajankohtaista_2024_11_25 from "../ajankohtaista/2024-11-25-pikkujoulut.svelte";
    import Ajankohtaista_2024_10_21 from "../ajankohtaista/2024-10-21-savotta_throwdown.svelte";
    import Ajankohtaista_2024_08_29 from "../ajankohtaista/2024-08-29-kehonhuolto_jatkuu.svelte";
    import Ajankohtaista_2024_08_01 from "../ajankohtaista/2024-08-01_avoimet-ovet-ja-dynamobattle.svelte";
    import Ajankohtaista_2024_04_21 from "../ajankohtaista/2024-04-21_fysiosari.svelte";
    import Ajankohtaista_2024_01_18 from "../ajankohtaista/2024-01-18_kuntalaisille10.svelte";
    import Ajankohtaista_2023_12_28 from "../ajankohtaista/2023-12-28_ahkerin.svelte";
    

    export let summary = false;
    export let ajankohtaistaUrl = "";
    let selected;

    // Copy paste ylhäältä tähän listaan ja uusin ylimmäksi aina. Muuta ei tarvi tehdä.
    // Tässä osoite linkitetään samaan muuttujaan
    const tekstit = [
        {aUrl: "2025-06-20_juhannus", component: Ajankohtaista_2025_06_20},
        {aUrl: "2025-05-01_kesa_aikataulut", component: Ajankohtaista_2025_05_01},
        {aUrl: "2025-04-12_paasiainen", component: Ajankohtaista_2025_04_12},
        {aUrl: "2025-01-19-helmikuun-leirit", component: Ajankohtaista_2025_01_19},
        {aUrl: "2024-12-31_uusivuosi", component: Ajankohtaista_2024_12_31},
        {aUrl: "2024-12-21_jouluinfo", component: Ajankohtaista_2024_12_21},
        {aUrl: "2024-11-25_pikkujoulut", component: Ajankohtaista_2024_11_25},
        {aUrl: "2024-10-21-savotta_throwdown", component: Ajankohtaista_2024_10_21},
        {aUrl: "2024-08-29-kehonhuolto_jatkuu", component: Ajankohtaista_2024_08_29},
        {aUrl: "2024-08-01_avoimet-ovet-ja-dynamobattle", component: Ajankohtaista_2024_08_01},
        {aUrl: "2024-04-21_fysiosari", component: Ajankohtaista_2024_04_21},
        {aUrl: "2024-01-18_kuntalaisille10", component: Ajankohtaista_2024_01_18},
        {aUrl: "2023-12-28_ahkerin", component: Ajankohtaista_2023_12_28},
    ];

    tekstit.forEach(teksti => {
        if (ajankohtaistaUrl == teksti.aUrl) {
            selected = teksti.component;
        }
    });

</script>

{#if summary && ajankohtaistaUrl === ""}
    <div class="row">
        {#each {length: 3} as _, i}
            <article class="news col-xs-12 col-md-4">
                <svelte:component this={tekstit[i].component} short="true"/>
            </article>
        {/each}
    </div>
{:else if ajankohtaistaUrl === ""}
    <!-- Kaikki kirjoitukset -->
    <div class="page">
        <div class="container">
            <h1>Ajankohtaista</h1>
            <div class="row">
                {#each tekstit as teksti, i}
                    <article class="news col-xs-12 col-md-4 col-lg-4">
                        <svelte:component this={teksti.component} short="true"/>
                    </article>
                {/each}
            </div>
        </div>
    </div>
{:else if ajankohtaistaUrl != ""}
    <svelte:component this={selected}/>
{/if}
